async function processResponse(res: Response) {
    if (res.status === 200) {
        return res.json()
    }

    let response: {error: string} = {error: ''}
    try {
        response = await res.json()
    } catch (e) {
        throw new Error(res.statusText)
    }

    if (response.hasOwnProperty('error')) {
        throw new Error(response.error)
    }

    throw new Error(res.statusText)
}

export const requests = {
    get: function (path: string, headers?: HeadersInit) {
        return fetch(path, {headers: headers}).then(processResponse)
    },
    post: function (path: string, payload: BodyInit, headers?: HeadersInit) {
        return fetch(
            path,
            {headers: headers, method: "post", body: payload}
        ).then(processResponse)
    }
}